import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Navigation',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
